// tslint:disable: no-unbound-method
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigureService } from "app/configure/configure.service";
import { GenericService } from "app/shared/generic.service";
import { SplitPaymentRequest, SplitPaymentDetails, CancelSplitPaymentResponse, CancelSplitPaymentRequest, SplitPaymentCancellation } from "app/shared/model/splitPaymentDetails";

import { Observable, of } from "rxjs";

import { catchError } from "rxjs/operators";

@Injectable()
export class SplitPaymentsService {
    private readonly endpoint = "/splitter/payment-groups";
    private readonly splitPaymentEndpoint = "/splitter/split-payments";
    private readonly bookingEndpoint = "/bookings";
    private _isSplitPayment: boolean = false;
    cancellationPolicy: SplitPaymentCancellation;
    splitPaymentPGBookerId: string;

    constructor(
        private genericService: GenericService,
        private readonly config: ConfigureService,
        private http: HttpClient
    ) { }

    get isSplitPayment() {
        return this._isSplitPayment;
    }

    set isSplitPayment(val) {
        this._isSplitPayment = val;
    }

    splitCancellationPolicy() {
        return this.cancellationPolicy
    }

    getSplitPaymentPGBookerId() {
        return this.splitPaymentPGBookerId
    }

    getUParam(u: string, isFirst: boolean): string {
        const separator = (isFirst) ? '?' : '&';
        return (u) ? separator + 'u=' + u : '';
    }
    getSplitPayments(id: string, u: string): Observable<SplitPaymentDetails> {
        return this.http.get(`${this.config.params.apiClientUri}${this.endpoint}/${id}?include=split-payments${this.getUParam(u, false)}`, this.genericService.addAuthHeaders()).pipe(
            catchError(this.genericService.handleError));
    }

    paySplitPayment(obj: SplitPaymentRequest, u: string) {
        return this.http.post(`${this.config.params.apiClientUri}${this.endpoint}/${obj.data.id}/pay${this.getUParam(u, true)}`, { data: obj.data }, { observe: 'response' }).pipe(
            catchError(this.genericService.handleError));
    }

    confirmSplitPayment(id: string, u: string) {
        const endpoint = this.splitPaymentEndpoint + '/' + id + `/confirm${this.getUParam(u, true)}`;
        return this.http.post(
            `${this.config.params.apiClientUri}${endpoint}`, {}
        ).pipe(
            catchError(this.genericService.handleError));
    }

    getQRCode(id: string, u: string) {
        const endpoint = this.endpoint + '/' + id + `/qr${this.getUParam(u, true)}`;
        return this.http.get(
            `${this.config.params.apiClientUri}${endpoint}`, { ...this.genericService.addAuthHeaders(), responseType: 'blob' }
        ).pipe(
            catchError(this.genericService.handleError));
    }

    getCancellationPolicy(id: number, u: string) {
        const endpoint = `${this.bookingEndpoint}/${id}${this.getUParam(u, true)}`;
        return this.http.get(
            `${this.config.params.apiClientUri}${endpoint}`, {}
        ).pipe(
            catchError(this.genericService.handleError));
    }

    cancelBooking(id: number, u: string, payload: any): Observable<any> {
        const endpoint = this.bookingEndpoint + '/' + id + '/cancelled' + `${this.getUParam(u, true)}`;
        return this.http.post(
            `${this.config.params.apiClientUri}${endpoint}`, payload, { ...this.genericService.addAuthHeaders() }
        ).pipe(
            catchError(this.genericService.handleError));
    }

    cancelSplitPayment(id: string, u: string, payload: CancelSplitPaymentRequest): Observable<CancelSplitPaymentResponse> {
        const endpoint = this.splitPaymentEndpoint + '/' + id + `${this.getUParam(u, true)}`;
        return this.http.put(
            `${this.config.params.apiClientUri}${endpoint}`, payload, { ...this.genericService.addAuthHeaders() }
        ).pipe(
            catchError(this.genericService.handleError));
    }

    payRemaining(id: string, u: string, payload: any): Observable<any> {
        const endpoint = this.endpoint + '/' + id + `/capture${this.getUParam(u, true)}`;
        return this.http.post(
            `${this.config.params.apiClientUri}${endpoint}`, payload, { ...this.genericService.addAuthHeaders() }
        ).pipe(
            catchError(this.genericService.handleError));
    }

}
